import {
  getCurrentFacilityId,
  getCurrentUserId,
} from "@risalabs_frontend_org/auth-wrapper";
import { ScreenNamesForBigQuery } from "../../../../enums/eventsData";
import { EventsName } from "../../../../enums/eventsName";
import store from "../../../../redux/store/store";
import { apiWorkerManager } from "../../../../workerManagers/workerManager";

/**
 * Builds the common event payload for comments writeback validation modal analytics.
 *
 * Reads the current order and user information directly from the Redux store
 * and the member management token so it can be called from non-React contexts.
 *
 * @returns An object containing `patient_id`, `order_id`, `org_id`, `user_id`, and `user_email`.
 */
export const populateBasicDetailsForValidationModalEvents = () => {
  const { singleMedicalPaOrder } = store.getState().singleMedicalPaOrder;
  const { user } = store.getState().firebaseAuthentication;
  return {
    patient_id: singleMedicalPaOrder?.patient_id ?? "",
    order_id: singleMedicalPaOrder?.order_id ?? "",
    org_id: getCurrentFacilityId() ?? "",
    user_id: getCurrentUserId() ?? "",
    user_email: user?.email ?? "",
  };
};

/**
 * Logs a BigQuery analytics event when the user clicks "Proceed Anyway"
 * on the comments writeback validation modal, bypassing validation issues.
 */
export const logProceedAnywaysEvent = () => {
  const eventData = {
    ...populateBasicDetailsForValidationModalEvents(),
    event_name: EventsName.PROCEED_ANYWAYS_CLICKED,
    additional_data: {
      screen_name: ScreenNamesForBigQuery.BUSNIESS_OFFICE_SCREEN,
    },
  };
  apiWorkerManager.enqueueAndProcess(eventData);
};

/**
 * Logs a BigQuery analytics event when the user clicks "Make Changes"
 * on the comments writeback validation modal to go back and fix issues.
 */
export const logMakeChangesEvent = () => {
  const eventData = {
    ...populateBasicDetailsForValidationModalEvents(),
    event_name: EventsName.MAKE_CHANGES_CLICKED,
    additional_data: {
      screen_name: ScreenNamesForBigQuery.BUSNIESS_OFFICE_SCREEN,
    },
  };
  apiWorkerManager.enqueueAndProcess(eventData);
};
